import { useState, useRef, useEffect } from "react";
import { useI18n, LANGUAGES } from "@/lib/i18n";

export function LanguageSwitcher({ dropUp = false }: { dropUp?: boolean }) {
  const { lang, setLang } = useI18n();
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!open) return;
    const handler = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, [open]);

  const current = LANGUAGES.find((l) => l.code === lang)!;

  return (
    <div className="relative" ref={ref}>
      <button
        onClick={() => setOpen(!open)}
        className="p-2.5 rounded-full hover:bg-accent transition-colors text-xl leading-none"
        title={current.label}
      >
        {current.flag}
      </button>

      {open && (
        <div className={`absolute ${dropUp ? "bottom-full mb-1.5" : "top-full mt-1.5"} left-0 bg-popover border border-border rounded-xl shadow-lg py-1 min-w-[170px] z-50`}>
          {LANGUAGES.map((l) => (
            <button
              key={l.code}
              onClick={() => { setLang(l.code); setOpen(false); }}
              className={`flex items-center gap-3 w-full px-4 py-2.5 text-sm transition-colors ${
                l.code === lang
                  ? "text-foreground bg-accent"
                  : "text-popover-foreground hover:bg-accent"
              }`}
            >
              <span className="text-lg">{l.flag}</span>
              <span>{l.label}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
